import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as WhatsAppIcon } from './whatsApp.svg';

export const WhatsApp = IconHOC(WhatsAppIcon);
